import { render, staticRenderFns } from "./IncidentDetail.vue?vue&type=template&id=2d45d703&"
import script from "./IncidentDetail.vue?vue&type=script&lang=js&"
export * from "./IncidentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports